const APP_DOMAIN = 'CHOOSE_VEHICLE';

export const CHV_READY = `${APP_DOMAIN}/READY`;
export const CHV_INIT = `${APP_DOMAIN}/INIT`;
export const CHV_CHANGE_FAILURE = `${APP_DOMAIN}/CHANGE_FAILURE`;
export const CHV_CHANGE_SUCCESS = `${APP_DOMAIN}/CHANGE_SUCCESS`;
export const CHV_SELECTION_CHANGED = `${APP_DOMAIN}/SELECTION_CHANGED`;
// Sent when a row asks for its selected vehicle to be applied. This app has no footer to perform the switch, so
// the host does it.
export const CHV_APPLY_VEHICLE = `${APP_DOMAIN}/APPLY_VEHICLE`;
export const CHV_INIT_SUCCESS = `${APP_DOMAIN}/INIT_SUCCESS`;
export const CHV_SEARCH_SUCCESS = `${APP_DOMAIN}/SEARCH_SUCCESS`;
export const CHV_SEARCH_FAILURE = `${APP_DOMAIN}/SEARCH_FAILURE`;
export const CHV_WINDOW_HEIGHT_CHANGED = `${APP_DOMAIN}/WINDOW_HEIGHT_CHANGED`;
export const CHV_CATALOG_VEHICLE_SUCCESS = `${APP_DOMAIN}/CATALOG_VEHICLE_SUCCESS`;
export const CHV_CATALOG_VEHICLE_FAILURE = `${APP_DOMAIN}/CATALOG_VEHICLE_FAILURE`;
export const CDL_V3_EVENT = 'CDL_V3_EVENT';
export const CHV_AI_VEHICLE_SELECTED = `${APP_DOMAIN}/AI_VEHICLE_SELECTED`;
export const CHV_AI_BUILD_VEHICLE_SELECTED = `${APP_DOMAIN}/AI_BUILD_VEHICLE_SELECTED`;
